/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { RarityGuarantee } from '../../Gacha/Common/RarityGuarantee'

export const protobufPackage = 'Reality.Reality.Api'

export interface GachaRarityGuarantee {
  setId: number
  rarityGuarantee: RarityGuarantee[]
}

function createBaseGachaRarityGuarantee(): GachaRarityGuarantee {
  return { setId: 0, rarityGuarantee: [] }
}

export const GachaRarityGuarantee = {
  encode(
    message: GachaRarityGuarantee,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.setId !== 0) {
      writer.uint32(8).int64(message.setId)
    }
    for (const v of message.rarityGuarantee) {
      RarityGuarantee.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): GachaRarityGuarantee {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaRarityGuarantee()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.setId = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.rarityGuarantee.push(
            RarityGuarantee.decode(reader, reader.uint32())
          )
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaRarityGuarantee {
    return {
      setId: isSet(object.setId) ? Number(object.setId) : 0,
      rarityGuarantee: Array.isArray(object?.rarityGuarantee)
        ? object.rarityGuarantee.map((e: any) => RarityGuarantee.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GachaRarityGuarantee): unknown {
    const obj: any = {}
    message.setId !== undefined && (obj.setId = Math.round(message.setId))
    if (message.rarityGuarantee) {
      obj.rarityGuarantee = message.rarityGuarantee.map((e) =>
        e ? RarityGuarantee.toJSON(e) : undefined
      )
    } else {
      obj.rarityGuarantee = []
    }
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaRarityGuarantee>, I>>(
    object: I
  ): GachaRarityGuarantee {
    const message = createBaseGachaRarityGuarantee()
    message.setId = object.setId ?? 0
    message.rarityGuarantee =
      object.rarityGuarantee?.map((e) => RarityGuarantee.fromPartial(e)) || []
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
